/**
 * author: Patrick Vyn Badiang
 */
import { Box, Button, Typography } from "@mui/material";
import "../../App.css";

//Components
import FormSwiper from "./FormSwiper";

//Icons
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';

//Global Variables
import { useDirection } from "../../UtilityFunctions";

function FormsPage({activeSection}) {
  const direction = useDirection();

  const isActive = activeSection === "forms";
  return (
    <div 
    className={`animate__animated ${
      isActive ? "animate__fadeIn" : "animate__fadeOut"
        }`} 
        >
    <div className="form-entire-page" >
        
        {/** Forms Section */}
        {direction === "horizontal" ? (
          <>
          <Box sx={{borderRadius: "15px", pt: 4, pb: 13,display: "flex", flexDirection: "column", alignItems: "center", width: "60%", borderColor: "primary.main", backgroundColor: "rgba(22, 22, 22, 1)"}}>
            <Typography variant="h3" color="primary" sx = {{width: "60%", textAlign: "start", mb: "20px", mt: "10px"}}>  
              Forms:
            </Typography>
            <FormSwiper />
          </Box>
        <Box sx = {{height:"10px"}}/>
        <Box sx={{ display: "flex", flexDirection: direction === "horizontal" ? "row" : "column", justifyContent: direction === "horizontal" ? "center" : "start", alignItems: "center", width: "100%", height:"100%", mt: "10px"}}>
          
          {/** Footer section*/}
          <Box sx={{mt: 10, pt: 3, pb: 4, pr: 8, width: "100%", borderColor: "primary.main", backgroundColor: "rgba(22, 22, 22, 1)"}}>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start",  width: "100%", ml: "30px", mr: "30px", mb: "20px", height: "100%", gap: "30px",}}>

              <Button 
              href="https://www.linkedin.com/company/ascend-at-virginia-tech/" target="_blank"
              variant="contained" color="primary" sx={{ width: "100%", mt:"20px", height: "80px", borderRadius: "15px", bgcolor: "#6D6FE5" }} startIcon={<LinkedInIcon />}>
                LinkedIn
              </Button>
              
              <Button 
              href="https://www.instagram.com/ascendatvt/" target="_blank"
              variant="contained" color="primary" sx={{ width: "100%", mt:"20px", height: "80px", borderRadius: "15px", bgcolor: "#C65757" }} startIcon={<InstagramIcon />} >
                Instagram
              </Button>

              <Button 
              href="mailto:ascendatvt@gmail.com" 
              variant="contained" color="primary" sx={{ width: "100%", mt:"20px", height: "80px", borderRadius: "15px", bgcolor: "#EFEFEF" }} startIcon={<EmailIcon />} >
                Email 
              </Button>
            </Box>
          </Box>
        </Box>
        </>
        ) : (
        <>
        <Box sx = {{height:"10px"}}/>
        <Box sx={{ display: "flex", flexDirection: direction === "horizontal" ? "row" : "column", justifyContent: direction === "horizontal" ? "center" : "start", alignItems: "center", width: "100%", height:"100%", mt: "10px"}}>
          <Box sx={{borderRadius: "15px", pt: 1, pb: 5,display: "flex", flexDirection: "column", alignItems: "center", width: "90%", borderColor: "primary.main", backgroundColor: "rgba(22, 22, 22, 1)"}}>
            <Typography variant="h3" color="primary" sx = {{width: "60%", textAlign: "start", mb: "20px", mt: "30px"}}>  
              Forms:
            </Typography>
            <FormSwiper />
          </Box>

          {/**Left Side of Buttons and Calendar */}
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start",  width: direction === "horizontal" ? "30%": "80%", mb: "20px", height: "100%"}}>

            <Button 
            href="https://www.linkedin.com/company/ascend-at-virginia-tech/" target="_blank"
            variant="contained" color="primary" sx={{ width: "100%", mt:"40px", height: "80px", borderRadius: "15px", bgcolor: "#6D6FE5" }} startIcon={<LinkedInIcon />}>
              LinkedIn
            </Button>
            
            <Button 
            href="https://www.instagram.com/ascendatvt/" target="_blank"
            variant="contained" color="primary" sx={{ width: "100%", mt:"20px", height: "80px", borderRadius: "15px", bgcolor: "#C65757" }} startIcon={<InstagramIcon />} >
              Instagram
            </Button>

            <Button 
            href="mailto:ascendatvt@gmail.com" 
            variant="contained" color="primary" sx={{ width: "100%", mt:"20px", height: "80px", borderRadius: "15px", bgcolor: "#EFEFEF" }} startIcon={<EmailIcon />} >
              Email 
            </Button>
          </Box>
          <Box sx = {{height:"50px"}}/>
        </Box>
        </>
        )}

        
    </div>
    </div>
  );
}

export default FormsPage;